import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { hypertrackerTheme } from '@/globalStyles/theme';

const HypertrackerThemeProvider = ({ children }) => {
    return (
        <ThemeProvider theme={hypertrackerTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
};

export default HypertrackerThemeProvider;
